<template>
    <Transition name="modal">
        <div v-if="store.getters.openModal?.name === modalName" class="modal-mask" @click="$emit('close')">
            <div class="modal-container">
                <div class="modal-container--inner">
<!--                    <div class="modal-btn">-->
<!--                        <button-->
<!--                            class="modal-default-button"-->
<!--                            @click="$emit('close')">-->
<!--                        </button>-->
<!--                    </div>-->
                    <div class="modal-body" :class="modalClassName" @click.stop>
                        <slot name="body">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import {ref, defineProps} from "vue"
import { useStore } from 'vuex'

const store = ref(useStore())
const props = defineProps({
    modalName: String,
    modalClassName: String
})
</script>

<style>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(2, 2, 2, 0.80);
    display: flex;
    justify-content: center;
    transition: opacity 0.3s ease;
}
.modal-container {
    width: 100%;
    padding: 30px;
}
.modal-container--inner {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-body {
    background-color: #3A3A3A;
    overflow: hidden;
    margin: 0 auto;
}
.modal-default-button {
    width: 38px;
    height: 38px;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 11;
}
.modal-default-button .icon {
    width: 22px;
    height: auto;
}
.modal-enter-from {
    opacity: 0;
    transition: all .3s ease;
}

.modal-leave-to {
    opacity: 0;
}
.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    transition: all .3s ease;
}
@media screen and (max-width: 1024px) {
    .modal-default-button {
        width: 24px;
        height: 24px;
        top: 0;
    }
    .modal-default-button .icon {
        width: 12px;
    }
}
</style>
